import { ActionTree } from 'vuex';
import { ReactionState } from './state';
import RootState from '@/store/root_state';
import { ErrorHandler } from '@/helpers/errorHandler';
import i18n from '../../../i18n';
import { graphqlMutation, MICROSERVICES_ENUM, graphqlQuery } from '@/helpers/apollo';
import { addReaction, removeReaction, getContentsReactions } from '@/store/queries/westerosQueries';
import { westerosReactionsSource } from '@/settings/constants';
import { normalize } from 'normalizr';
import { reaction as reactionSchema } from '@descomplica/dex-store/lib/normalizr_schema';

export enum ReactionsEnum {
  LIKE = 'like',
  DISLIKE = 'dislike',
  EMPTY = '',
}

export interface ReactionInput {
  contentId: string;
  reaction: ReactionsEnum;
}

const actions: ActionTree<ReactionState, RootState> = {
  async GET_CONTENTS_REACTIONS({ commit }, contentsIds: string[]) {
    try {
      const { data } = await graphqlQuery(MICROSERVICES_ENUM.REACTIONS, getContentsReactions, {
        contentsIds,
        source: westerosReactionsSource,
      });

      const { entities } = normalize(data.getContentsReactions, [reactionSchema]);

      commit('SET_REACTIONS', entities);
    } catch (error) {
      ErrorHandler.showErrorMessage({
        error,
        customMessage: i18n.tc('loadReactionErrorMessage').toString(),
      });
    }
  },

  async ADD_REACTION({ commit }, reaction: ReactionInput) {
    try {
      commit('ADD_NEW_REACTION', reaction);
      await graphqlMutation(MICROSERVICES_ENUM.REACTIONS, addReaction, {
        ...reaction,
        source: westerosReactionsSource,
      });
    } catch (error) {
      commit('REMOVE_REACTION', reaction);
      ErrorHandler.showErrorMessage({
        error,
        customMessage: i18n.tc('addReactionErrorMessage').toString(),
      });
    }
  },

  async REMOVE_REACTION({ commit }, reaction: ReactionInput) {
    try {
      commit('REMOVE_REACTION', reaction);
      await graphqlMutation(MICROSERVICES_ENUM.REACTIONS, removeReaction, {
        ...reaction,
        source: westerosReactionsSource,
      });
    } catch (error) {
      commit('ADD_NEW_REACTION', reaction);
      ErrorHandler.showErrorMessage({
        error,
        customMessage: i18n.tc('removeReactionErrorMessage').toString(),
      });
    }
  },
};

export default actions;
